import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import berita from '../views/Berita/berita.vue'
import isiBerita from '../views/Berita/isiBerita.vue'
import dataPegawai from '../views/profil/datapegawai.vue'
import strukturOrganisasi from '../views/profil/strukturOrganisasi.vue'
import tentangKami from '../views/profil/tentangKami.vue'
import visiMisi from '../views/profil/visiMisi.vue'
import data from '../views/data/data.vue'
import foto from '../views/galeri/foto.vue'
import video from '../views/galeri/video.vue'
import skm from '../views/skm/skm.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/berita',
    name: 'berita',
    component: berita
  },
  {
    path: '/isiBerita',
    name: 'isiBerita',
    component: isiBerita
  },
  {
    path: '/dataPegawai',
    name: 'dataPegawai',
    component: dataPegawai
  },
  {
    path: '/strukturOrganisasi',
    name: 'strukturOrganisasi',
    component: strukturOrganisasi
  },
  {
    path: '/tentangKami',
    name: 'tentangKami',
    component: tentangKami
  },
  {
    path: '/visiMisi',
    name: 'visiMisi',
    component: visiMisi
  },
  {
    path: '/data',
    name: 'data',
    component: data
  },
  {
    path: '/foto',
    name: 'foto',
    component: foto
  },
  {
    path: '/video',
    name: 'video',
    component: video
  },
  {
    path: '/skm',
    name: 'skm',
    component: skm
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
